// Test utility for API integration
import {
  fetchAllNews,
  fetchCryptoNews,
  fetchCommoditiesNews,
} from "./apiServices";

export const testApiIntegration = async () => {
  console.log("🧪 Testing API Integration...");

  try {
    // Test individual APIs
    console.log("📡 Testing CryptoPanic API...");
    const cryptoNews = await fetchCryptoNews(2);
    console.log(
      "✅ CryptoPanic API:",
      cryptoNews.length > 0 ? "Working" : "No data"
    );

    console.log("📡 Testing Marketaux API...");
    const commoditiesNews = await fetchCommoditiesNews(2);
    console.log(
      "✅ Marketaux API:",
      commoditiesNews.length > 0 ? "Working" : "No data"
    );

    // Test combined function
    console.log("📡 Testing combined news fetch...");
    const allNews = await fetchAllNews();
    console.log("✅ Combined API:", allNews.length > 0 ? "Working" : "No data");
    console.log("📊 Total articles fetched:", allNews.length);

    // Log sample data structure
    if (allNews.length > 0) {
      console.log("📋 Sample article structure:", {
        title: allNews[0].title,
        category: allNews[0].category,
        source: allNews[0].source,
        hasUrl: !!allNews[0].url,
      });
    }

    return {
      success: true,
      cryptoCount: cryptoNews.length,
      commoditiesCount: commoditiesNews.length,
      totalCount: allNews.length,
    };
  } catch (error) {
    console.error("❌ API Test failed:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Function to check if API keys are configured
export const checkApiKeys = () => {
  const cryptopanicKey = process.env.REACT_APP_CRYPTOPANIC_API_KEY;
  const marketauxKey = process.env.REACT_APP_MARKETAUX_API_KEY;

  console.log("🔑 API Key Status:");
  console.log("CryptoPanic:", cryptopanicKey ? "✅ Configured" : "❌ Missing");
  console.log("Marketaux:", marketauxKey ? "✅ Configured" : "❌ Missing");

  return {
    cryptopanicConfigured: !!cryptopanicKey,
    marketauxConfigured: !!marketauxKey,
    allConfigured: !!(cryptopanicKey && marketauxKey),
  };
};
